/* eslint-disable no-unused-vars */
import React, {
  Component,
  useContext,
  useRef,
  useCallback,
  useEffect,
} from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

// import survey from '../../context/survey';

// ---------------
import WidgetPermission from './sequences/WidgetPermission';
import WidgetNps from './sequences/WidgetNps';
import WidgetInquiry from './sequences/WidgetInquiry';
import WidgetThanks from './sequences/WidgetThanks';

/**
 * {@link WidgetPermission} > {@link Permission}
 * @param {*} state React.Context survey.state
 * @param {function} dispatch React.Context survey.dispatch
 * @param {boolean} embedded embedded flag
 * @param {boolean} desktop desktop size flag
 * @param {*} props React.props
 * @return {null|*} React.node
 * @constructor
 * @since 20191211 - Component を分割する
 */
const WidgetSequencePermission = ({
  state,
  dispatch,
  embedded,
  desktop,
  ...props
}) => {
  const { config } = state;

  // Permission - index を算出します
  const permissionStep = useCallback(() => {
    // embedded - Permission 非表示
    if (embedded) {
      return -1;
    }
    return config.permission.available ? 0 : -1;
  }, [config, embedded]);

  if (embedded) {
    return null;
  }

  return (
    config.permission.available && (
      <WidgetPermission
        index={permissionStep()}
        state={state}
        dispatch={dispatch}
        embedded={embedded}
        desktop={desktop}
        {...props}
      />
    )
  );
};

/**
 * {@link WidgetNps} > {@link Nps}
 * @param {*} state React.Context survey.state
 * @param {function} dispatch React.Context survey.dispatch
 * @param {boolean} embedded embedded flag
 * @param {boolean} desktop desktop size flag
 * @param {*} props React.props
 * @return {*} React.node
 * @constructor
 * @since 20191211 - Component を分割する
 */
const WidgetSequenceNps = ({
  state,
  dispatch,
  embedded,
  desktop,
  ...props
}) => {
  const { config } = state;

  // Nps - index を算出します
  const npsStep = useCallback(() => {
    // embedded - Nps 必須 / Permission 非表示
    if (embedded) {
      return 0;
    }

    if (!config.nps.available) {
      return -1;
    }
    return config.permission.available ? 1 : 0;
  }, [config, embedded]);

  // if (embedded && desktop) {
  //   return null;
  // }
  if (embedded) {
    // desktop / mobile 双方埋め込む
    return null;
  }

  // console.log('WidgetSequenceNps ', config.nps.available, embedded, desktop);
  return (
    (config.nps.available || embedded) && (
      <WidgetNps
        index={npsStep()}
        state={state}
        dispatch={dispatch}
        embedded={embedded}
        desktop={desktop}
        {...props}
      />
    )
  );
};

/**
 * {@link WidgetInquiry} > {@link Inquiry}
 * @param {*} state React.Context survey.state
 * @param {function} dispatch React.Context survey.dispatch
 * @param {boolean} embedded embedded flag
 * @param {boolean} desktop desktop size flag
 * @param {*} props React.props
 * @return {*} React.node
 * @constructor
 * @since 20191211 - Component を分割する
 */
const WidgetSequenceInquiry = ({
  state,
  dispatch,
  embedded,
  desktop,
  ...props
}) => {
  const { config } = state;

  // Inquiry - index を算出します
  const inquiryStep = useCallback(() => {
    if (embedded) {
      return 1;
    }

    let i = 0;
    if (config.permission.available) {
      i += 1;
    }
    if (config.nps.available) {
      i += 1;
    }
    return i;
  }, [config, embedded]);

  return (
    <WidgetInquiry
      index={inquiryStep()}
      onSendClick={props.onSendClick}
      state={state}
      dispatch={dispatch}
      embedded={embedded}
      desktop={desktop}
      {...props}
    />
  );
};

/**
 * {@link WidgetThanks} > {@link Thanks}
 * @param {*} state React.Context survey.state
 * @param {function} dispatch React.Context survey.dispatch
 * @param {boolean} embedded embedded flag
 * @param {boolean} desktop desktop size flag
 * @param {*} props React.props
 * @return {null|*} React.node
 * @constructor
 * @since 20191211 - Component を分割する
 */
const WidgetSequenceThanks = ({
  state,
  dispatch,
  embedded,
  desktop,
  ...props
}) => {
  if (embedded && desktop) {
    return null;
  }

  return (
    <WidgetThanks
      state={state}
      dispatch={dispatch}
      embedded={embedded}
      {...props}
    />
  );
};

/**
 * survey widget - 表示順を管理します
 * - 最初に表示する component はアニメーションしません
 * - 以後、登場時に `fadeInUp` アニメーションします
 * - 各 widget - available check し index を割り当てます
 * - config.step === index の時に widget を表示します
 * @param {*} state React.Context config.state
 * @param {function} dispatch React.Context config.dispatch
 * @param {boolean} embedded React.Context.survey.state.config.embedded - 埋め込みフラッグ
 * @param {boolean} desktop resize: desktop size flag
 * @param {*} props React.props
 * @return {*} React.node 各カードを返します
 * @constructor
 */
const WidgetSequence = ({ state, dispatch, embedded, desktop, ...props }) => {
  // @since 20191211 - Component を分割する
  return (
    <>
      <WidgetSequencePermission
        state={state}
        dispatch={dispatch}
        embedded={embedded}
        desktop={desktop}
        {...props}
      />
      <WidgetSequenceNps
        state={state}
        dispatch={dispatch}
        embedded={embedded}
        desktop={desktop}
        {...props}
      />
      <WidgetSequenceInquiry
        state={state}
        dispatch={dispatch}
        embedded={embedded}
        desktop={desktop}
        {...props}
      />
      <WidgetSequenceThanks
        state={state}
        dispatch={dispatch}
        embedded={embedded}
        desktop={desktop}
        {...props}
      />
    </>
  );
};

export default WidgetSequence;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/widget/WidgetSequence.js